import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageJumpArrowsComponent } from './page-jump-arrows.component';

@NgModule({
  declarations: [PageJumpArrowsComponent],
  imports: [CommonModule, NzButtonModule, NzIconModule],
  exports: [PageJumpArrowsComponent]
})
export class PageJumpArrowsModule {}
